type DesoExternalIdTextField = {
  formatExternalId: (value: string) => string;
};

const useDesoExternalIdTextField = (): DesoExternalIdTextField => {
  const formatExternalId = (value: string): string => {
    if (!value) return '';

    return value.replaceAll(/\D/g, '').slice(0, 5);
  };

  return {
    formatExternalId,
  };
};

export default useDesoExternalIdTextField;
